// extracted by mini-css-extract-plugin
module.exports = {"labels":"Labels_labels__3OjBJ"};